import { Component,  OnDestroy, OnInit } from "@angular/core";
import { UtilHelper, ApiResources } from "@shared/helpers";
import { Setting } from "../../entities";
import { HttpService, PrintOptionService } from "../../services";
import { Page } from "../../models";


@Component({
    template: `<div *ngIf="isPrintLogo" class="text-center p-1">
<img  [src]="url != null ? url : myImgUrl" alt="Careaxes" style="height:100px; max-width:100%;" />
</div>`,
    selector: "banner-setting"   
})

export class BannerSettingWidget implements OnInit, OnDestroy{
    page: Page;
    myImgUrl: string;
    url: string;
    isPrintLogo: boolean;
    constructor(
        private readonly httpService: HttpService,
        private readonly printOptionService: PrintOptionService
    ) {
        this.page = new Page();
    }
    getBannerImage() {

        this.httpService
            .get<Array<Setting>>(ApiResources.getURI(ApiResources.setting.base, ApiResources.setting.fetch), { type: "Banner",active:true }, true)
            .subscribe(
                (response: Array<Setting>) => {
                    if (response && response.length > 0) {
                        if (UtilHelper.isEmpty(response[0].imageUrl)) {
                            response[0].imageUrl = `${ApiResources.getURI(ApiResources.resources.base, ApiResources.resources.getProfileImage)}?imagePath=${response[0].imageUrl}`;
                            this.url = response[0].imageUrl;
                        }
                    }
                },
                () => {
                    this.url = null;
                }
            );
    }

    ngOnInit() {      
        this.printOptionService.get((is) => { this.isPrintLogo = is; });
        this.getBannerImage();
    }

    ngOnDestroy() {
        this.page.unsubscribeAll();
    }
}